import React, { Suspense, lazy } from "react";
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom";

import { Box } from "@material-ui/core";

import ListingLayout from "../../../Components/UI/ListingLayout";

const Listing = lazy(() => import("./"));
const Reports = lazy(() => import("./BreakdownReport/"));

const WebsiteTabs = () => {
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();

  const prepath = `/d/location/edit/${id}/website-enquiries`;

  const paths = [
    {
      title: "Enquiries",
      path: `${prepath}/listing`,
      path_to_go: `${prepath}/listing`,
      render: <Listing id={id} />,
    },
    {
      title: "Acquisition Report",
      path: `${prepath}/acquisition`,
      path_to_go: `${prepath}/acquisition`,
      render: <Reports id={id} />,
    },
  ];
  return (
    <>
      <ListingLayout
        title={`Enquiry`}
        mode={`Update`}
        pageName="Profile"
        parentLink="/"
        childLink="/"
        customTitle={``}
        showLocationToggle={true}
        history={history}
        hidePageHeader={true}
        hideHeader={true}
        hideAdd={true}
        paths={paths}
        showProfileTabs={true}
        profileLocation={location}
        hasMediumContent={true}
      >
        <Box mb="1rem">
          <Suspense fallback={<></>}>
            <Switch>
              {paths.map((item) => (
                <Route exact path={item?.path} render={() => item.render} />
              ))}
            </Switch>
          </Suspense>
        </Box>
      </ListingLayout>
    </>
  );
};

export default WebsiteTabs;
